export default __webpack_public_path__ + "static/media/removeFile.1160f866.svg";